import { app } from '../../../../../app';
import { Controller } from './integration-office-365.controller';

app.component('companyManageApplicationIntegrationDevelopersIntegrationOffice365', {
    controller: Controller,
    templateUrl: require('./integration-office-365.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/integration-office-365/integration-office-365.component.js